// extracted by mini-css-extract-plugin
export default {"container":"interactive-tile-area-module__container___Mjf1T"};